import React from 'react';
import { Users } from 'lucide-react';
import { API_ENDPOINTS } from '../../config/api';
import { t } from '../../i18n/languages';

const CollectiveVacationForm = ({
  show,
  setShowCollectiveVacationForm,
  collectiveVacationData,
  setCollectiveVacationData,
  collectiveVacations,
  fetchCollectiveVacations,
  loadWorkStatusesForMonth,
  currentMonth,
  showDeleteConfirmation,
  currentLanguage
}) => {
  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(API_ENDPOINTS.ADMIN_COLLECTIVE_VACATION, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          date: collectiveVacationData.date,
          description: collectiveVacationData.description || ''
        })
      });

      if (response.ok) {
        setCollectiveVacationData({ date: '', description: '' });
        fetchCollectiveVacations();
        loadWorkStatusesForMonth(currentMonth);
      } else {
        const error = await response.json();
        alert(t('error', { error: error.message }, currentLanguage));
      }
    } catch (error) {
      alert(t('errorSettingCollectiveVacation', {}, currentLanguage));
    }
  };

  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '12px',
      padding: '24px',
      marginBottom: '24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <Users size={20} color="#f59e0b" />
        {t('setCollectiveVacattion', {}, currentLanguage)}
      </h3>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px', marginBottom: '20px' }}>
          <div>
            <label style={labelStyle}>{t('date', {}, currentLanguage)}</label>
            <input
              type="date"
              value={collectiveVacationData.date}
              onChange={(e) => setCollectiveVacationData({ ...collectiveVacationData, date: e.target.value })}
              style={inputStyle}
              required
            />
          </div>

          <div>
            <label style={labelStyle}>{t('description', {}, currentLanguage)}</label>
            <input
              type="text"
              value={collectiveVacationData.description}
              onChange={(e) => setCollectiveVacationData({ ...collectiveVacationData, description: e.target.value })}
              placeholder={t('placeholder', {}, currentLanguage)}
              style={inputStyle}
            />
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            type="submit"
            style={submitBtnStyle}
          >
            {t('setCollectiveVacattion', {}, currentLanguage)}
          </button>

          <button
            type="button"
            onClick={() => {
              setCollectiveVacationData({ date: '', description: '' });
              setShowCollectiveVacationForm(false); // CLOSE FORM in parent
            }}
            style={cancelBtnStyle}
          >
            {t('cancel', {}, currentLanguage)}
          </button>
        </div>
      </form>

      {/* Existing Collective Vacations */}
      <div style={{ marginTop: '24px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
        <h4 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '16px'
        }}>
          {t('existingCollectiveVacations', {}, currentLanguage)}
        </h4>

        {collectiveVacations.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {collectiveVacations.map((vacation) => (
              <div key={vacation.id} style={vacationItemStyle}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Users size={16} color="#f59e0b" />
                  <span style={{ fontWeight: '500', color: '#1f2937' }}>
                    {new Date(vacation.date).toLocaleDateString(currentLanguage === 'hr' ? 'hr-HR' : 'en-US')}
                  </span>
                  {vacation.description && (
                    <span style={{ color: '#6b7280', fontSize: '14px' }}>
                      - {vacation.description}
                    </span>
                  )}
                </div>

                <button
                  onClick={() => showDeleteConfirmation(vacation)}
                  style={deleteBtnStyle}
                >
                  {t('remove', {}, currentLanguage)}
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div style={noVacationStyle}>
            {t('noCollectiveVacations', {}, currentLanguage)}
          </div>
        )}
      </div>
    </div>
  );
};

const labelStyle = { display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' };
const inputStyle = { width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' };
const submitBtnStyle = { padding: '12px 24px', backgroundColor: '#f59e0b', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' };
const cancelBtnStyle = { padding: '12px 24px', backgroundColor: '#6b7280', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' };
const vacationItemStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#fef3c7', border: '1px solid #f59e0b', borderRadius: '8px' };
const deleteBtnStyle = { padding: '6px 12px', backgroundColor: '#dc2626', color: 'white', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' };
const noVacationStyle = { padding: '16px', backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', textAlign: 'center', color: '#6b7280', fontSize: '14px' };

export default CollectiveVacationForm;
